import {useSelector} from 'react-redux'
import {getUserAgentDetails} from 'modules/meta/selectors'

import {isGooglebot} from '@vio/core/src/_web/utils/userAgent'

export const useIsCrawler = (): boolean => {
  const userAgentDetails = useSelector(getUserAgentDetails)

  return isGooglebot(userAgentDetails?.source)
}
